export const hardwareCategoryType = [
  // Sailaja sorting the Optical network -> Add OLT-> Hardware Category dropdown data as alphabetical order on 24th March 2023
  {
    id: "CT",
    name: "Cable TV",
  },
  {
    id: "INT",
    name: "Internet",
  },

];

export const makeType = [
  // {
  //   id: "MTK",
  //   name: "Mikrotik",
  // },
  // {
  //   id: "CIS",
  //   name: "Cisco",
  // },
  // {
  //   id: "JUN",
  //   name: "Juniper",
  // },
  // {
  //   id: "HUW",
  //   name: "Huawei",
  // },
  // {
  //   id: "ATL",
  //   name: "Alcatel",
  // },
  // {
  //   id: "HB",
  //   name: "HB",
  // }
  {
    id: "DBC",
    name: "DBC"
  },
   
  {
    id: "KWSH",
    name: 'Khwahish'
  },

  {
    id: "OTLK",
    name: "Optilink",
  },
  {
    id: "SRT",
    name: "Syrotech",
  },
  {
    id: "TJS",
    name: "Tejas"
  },
  
  {
    id: "TS",
    name: "Timescope"
  },



]